import { render, staticRenderFns } from "./customerMOQ.vue?vue&type=template&id=fe6536d8&scoped=true&"
import script from "./customerMOQ.vue?vue&type=script&lang=js&"
export * from "./customerMOQ.vue?vue&type=script&lang=js&"
import style0 from "./customerMOQ.vue?vue&type=style&index=0&id=fe6536d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6536d8",
  null
  
)

export default component.exports